import React from "react";
import { useNavigate } from "react-router-dom";
import "./NavBar.scss";
import { FiGrid, FiCamera, FiUser, FiSettings } from "react-icons/fi";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const NavBar: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateConsent = () => {
    navigate("/new-consentBundle");
  };

  return (
    <header className="mc-nav">
      <div className="mc-nav__left">
        {/* logo mark (optional image). replace src or remove <img> if not needed */}
        <img
          className="mc-nav__logo"
          src="/logo.png"
          alt="Medicube"
          onError={(e) => ((e.currentTarget.style.display = "none"))}
        />
      </div>

      <nav className="mc-nav__center" aria-label="Main">

         <a className="mc-nav__link is-active" href="/welcome">
          <FavoriteBorderIcon className="mc-nav__icon" />
          <span>Welcome</span>
        </a>

        <a className="mc-nav__link is-active" href="/new-dashboard">
          <FiGrid className="mc-nav__icon" />
          <span>Dashboard</span>
        </a>

        <a className="mc-nav__link" href="/video-gallery">
          <FiCamera className="mc-nav__icon" />
          <span>Video Gallery</span>
        </a>

        <a className="mc-nav__link" href="/templates">
          <FiUser className="mc-nav__icon" />
          <span>My Consent Templates</span>
        </a>

        <a className="mc-nav__link" href="/my-plan">
          <FiSettings className="mc-nav__icon" />
          <span>My Plan</span>
        </a>
      </nav>

      <div className="mc-nav__right">
        <button
          className="mc-btn mc-btn--primary"
          onClick={handleCreateConsent}
        >
          Create consent form
        </button>
      </div>
    </header>
  );
};

export default NavBar;
